import {
  ResolvedStateItem, ResolvedState, TaskItem, TrelloData,
} from '../../shared/types/types';
import {
  defaultTrelloData,
  getTrelloBoardsAPIResponse,
  TrelloAPIBoard,
  isTrelloBoardsEnabled, mapTasksToTrelloTask, TrelloBoardMember, TrelloTaskCreate, TrelloUpdateObj,
} from './trelloUtils';
import { dbTaskUpdateTrelloData } from '../../database/firebaseTasksAPI';
import { toastInfo } from '../notifications';
import { TabDropdownItem } from '../../shared/components/simple-dropdown';
import CloudFunctions from '../../database/CloudFunctions';

export const getUsersTrelloSetting = (
  emailId: string,
): Promise<ResolvedStateItem<TrelloData>> => CloudFunctions()
  .searchUserDataByEmail({ email: emailId })
  .then((response: any) => {
    const result: ResolvedStateItem<TrelloData> = {
      item: response.data.integrations.trello,
      resolvedState: 'resolved',
    };
    return result;
  }).catch(() => {
    const result: ResolvedStateItem<TrelloData> = {
      item: defaultTrelloData,
      resolvedState: 'rejected',
    };
    return result;
  });

export const getTrelloWorkspace = (
  accessToken: string,
): Promise<ResolvedStateItem<TabDropdownItem[]>> => CloudFunctions()
  .getTrelloWorkspaces({ accessToken })
  .then((data: any) => {
    const result: ResolvedStateItem<TabDropdownItem[]> = {
      item: data.data,
      resolvedState: 'resolved',
    };
    return result;
  }).catch(() => {
    const result: ResolvedStateItem<TabDropdownItem[]> = {
      item: [],
      resolvedState: 'rejected',
    };
    return result;
  });

export const getTrelloBoardMembers = (
  accessToken: string, boardId: string,
): Promise<ResolvedStateItem<TrelloBoardMember[]>> => CloudFunctions()
  .getTrelloBoardMembers({ accessToken, boardId })
  .then((data: any) => {
    const result: ResolvedStateItem<TrelloBoardMember[]> = {
      item: data.data,
      resolvedState: 'resolved',
    };
    return result;
  }).catch(() => {
    const result: ResolvedStateItem<TrelloBoardMember[]> = {
      item: [],
      resolvedState: 'rejected',
    };
    return result;
  });

export const getTrelloBoards = (
  accessToken: string, workspaceId: string,
): Promise<ResolvedStateItem<getTrelloBoardsAPIResponse[]>> => CloudFunctions()
  .getTrelloBoards({ accessToken, workspaceId })
  .then((data: any) => {
    const result: ResolvedStateItem<getTrelloBoardsAPIResponse[]> = {
      item: data.data,
      resolvedState: 'resolved',
    };
    return result;
  }).catch(() => {
    const result: ResolvedStateItem<getTrelloBoardsAPIResponse[]> = {
      item: [],
      resolvedState: 'rejected',
    };
    return result;
  });

export const getTrelloBoardsList = (
  accessToken: string, boardId: string,
): Promise<ResolvedStateItem<TrelloAPIBoard[]>> => CloudFunctions()
  .getTrelloBoardList({ accessToken, boardId })
  .then((data: any) => {
    const result: ResolvedStateItem<TrelloAPIBoard[]> = {
      item: data.data,
      resolvedState: 'resolved',
    };
    return result;
  }).catch(() => {
    const result: ResolvedStateItem<TrelloAPIBoard[]> = {
      item: [],
      resolvedState: 'rejected',
    };
    return result;
  });

export const sendTaskToTrelloBoard = async (
  trelloChecked: boolean,
  selectedTasks: TaskItem[],
  trelloUserData: TrelloData,
): Promise<ResolvedState> => {
  if (isTrelloBoardsEnabled(trelloUserData)) {
    const tasks: TrelloTaskCreate[] = await mapTasksToTrelloTask(selectedTasks, trelloUserData);
    return CloudFunctions()
      .sendTaskToTrelloBoard({ accessToken: trelloUserData.accessToken, tasks })
      .then((data: any) => {
        const promiseArr = data.data.map(
          (idObj: {
          taskId: string, trelloId: string
        }) => dbTaskUpdateTrelloData(idObj.taskId, idObj.trelloId, trelloChecked),
        );
        return Promise.all(promiseArr).then(() => 'resolved' as ResolvedState).catch((error) => {
          console.log(error);
          return 'rejected' as ResolvedState;
        });
      });
  }
  toastInfo('Trello Integration Error', 'Trello board have not been setup');
  return 'rejected' as ResolvedState;
};

export const updateTrelloTask = (
  updateObj: TrelloUpdateObj,
): Promise<ResolvedState> => CloudFunctions()
  .updateTaskInTrelloBoard({ ...updateObj })
  .then(() => 'resolved' as ResolvedState)
  .catch(() => 'rejected' as ResolvedState);

export const deleteTrelloTask = (
  taskId: string, emailId: string,
): Promise<ResolvedState> => getUsersTrelloSetting(emailId)
  .then((response) => CloudFunctions().deleteTrelloCard(
    { accessToken: response.item.accessToken, taskId },
  )
    .then(() => {
      console.log('taskDeleted in trello', new Date());
      return 'resolved' as ResolvedState;
    })
    .catch((error: any) => {
      console.log(JSON.stringify(error));
      return 'rejected' as ResolvedState;
    }));
